import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CardComponent } from '@gelato-api-ui/ui-kit/src/lib/cards/card/card.component';
import { Card, CardDropdownMenuItem, DropdownMenuItemClick } from '@gelato-api-ui/ui-kit/src/lib/cards/types/cards';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@Component({
  standalone: true,
  imports: [CommonModule, CardComponent, InfiniteScrollModule],
  selector: 'ui-card-list',
  templateUrl: './card-list.component.html',
  styleUrls: ['./card-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardListComponent {
  // FIXME: remove any and fix type
  @Input() cards: Card[] | any;
  @Input() overlayBtnText: string;
  @Input() dropdownMenuItems: CardDropdownMenuItem[];
  @Input() infiniteScrollContainer = '.layout-content';

  @Output() dropdownMenuItemClick = new EventEmitter<DropdownMenuItemClick>();
  @Output() cardClick = new EventEmitter<Card>();
  @Output() scrollDown = new EventEmitter<void>();

  itemTrackBy(index: number) {
    return index;
  }

  onScrollDown() {
    this.scrollDown.emit();
  }
}
